import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var MaxCapacityIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M15.2 4.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zm-7 3a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zm2.9 2.1a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-5 6a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm11.1-2.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zm-7.1 6.1a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm7.1.9a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zm-12.1-.9a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm7-3a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm1.1-5.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zm-9.1 1.1a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM6.2 9.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zm-.1 11.1a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM5.2 5.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM3.1 15.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm18.1-8.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zm-2.1 10.1a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
MaxCapacityIcon.isCarinaIcon = true;
export default MaxCapacityIcon;
